module.exports = __webpack_public_path__ + "img/title-5.f065094c.png";